import { combineReducers } from 'redux';
import { reducer as alertDiagnostics } from './alertDiagnostics';
import { reducer as nocDrilldown } from './nocDrilldown';
import { reducer as aiAlertDiagnostics } from './aiAlertDiagnostics';


export default combineReducers({
  alertDiagnostics,
  nocDrilldown,
  aiAlertDiagnostics,
});
